export default "__VITE_ASSET__liLr9wa___"